/**
 *
 * ServiceType12970 constants
 *
 */

export const AGREEMENT_OF_SB_REQUESTS = '3990454677000';
export const AGREEMENT_OF_UK_REQUESTS = '3990454662000';
